import { RoomApi, FrontRoomApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const roomApi = {
  searchForAdmin: wrap(RoomApi, RoomApi.prototype.indexRoomForAdmin),
  searchForSales: wrap(RoomApi, RoomApi.prototype.indexRoomForSales),
  show: wrap(RoomApi, RoomApi.prototype.showRoom),
  create: wrap(RoomApi, RoomApi.prototype.createRoom),
  update: wrap(RoomApi, RoomApi.prototype.updateRoom),
  select: wrap(FrontRoomApi, FrontRoomApi.prototype.frontRoomSelect),
  index: wrap(FrontRoomApi, FrontRoomApi.prototype.indexRoomList),
};
